import { Stack } from '@mui/material';

import EditorInfoImage from '@/shared/assets/images/auth/auth-info-editor.png';

import { SImage } from './styled';

export const EditorInfo = () => {
  return (
    <Stack alignItems="end">
      <SImage alt="editor info" src={EditorInfoImage} />
    </Stack>
  );
};
